import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class LineService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('line/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('line/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('line/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('line/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('line/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('line/delete', val_id);
  }
}
